import { ActionType, createAction } from 'typesafe-actions';

export const agencyLogoActions = {
  getAgencyLogo: createAction('@agencyLogo/GET_AGENCY_LOGO')(),
  getAdminAgencyLogo: createAction('@agencyLogo/GET_ADMIN_AGENCY_LOGO')<string>(),
  saveAgencyLogo: createAction('@agencyLogo/SAVE_AGENCY_LOGO')<string>()
};

export type AgencyLogoActions = ActionType<typeof agencyLogoActions>;
